import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Offer } from 'app/services/offers/offer.model';
import { Approval } from 'ng2-app/models/dto/approval/approval.model';
import { OfferOption } from 'ng2-app/models/dto/offer-option/offer-option.model';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Store } from '@ngxs/store';
import { DeleteOfferOption, UpdateOfferOptionTerms } from 'ng2-app/store/offers/offer-options.actions';

@Component({
  selector: 'app-offer-option-delete-modal',
  templateUrl: './offer-option-delete-modal.component.html',
  styleUrls: ['./offer-option-delete-modal.component.scss']
})
export class OfferOptionDeleteModalComponent implements OnInit {

  @Input() option: OfferOption;

  @Output() offerOptionDeleted = new EventEmitter<object>(); 

  @ViewChild('deletionModal', { static: true }) private deletionModal: ModalDirective;


  constructor(
    private store: Store,
  ) { }

  ngOnInit(): void { }

  openModal() {
      this.deletionModal.show();
  }

  closeModal() {
    this.deletionModal.hide();
  }

  deleteOption() {
    this.store.dispatch(new DeleteOfferOption(this.option.dealId, this.option.id,));
    this.offerOptionDeleted.emit();
    this.closeModal();
  }

}
